import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
export class JsonSchemaCleaner {
    wasCleaned() {
        return this.cleaned;
    }
    getCleaned() {
        return JSON.stringify(this.cleanedNodes);
    }
    clean(json) {
        var _this_cleanInvalidNodes;
        return (_this_cleanInvalidNodes = this.cleanInvalidNodes(json, 'doc')) !== null && _this_cleanInvalidNodes !== void 0 ? _this_cleanInvalidNodes : {};
    }
    cleanInvalidNodes(jsonContent, contextType) {
        if (!this.isValidNode(jsonContent, contextType)) {
            this.cleaned = true;
            this.cleanedNodes.push(jsonContent);
            return null;
        }
        const cleanedContent = _object_spread({}, jsonContent);
        if (jsonContent.content && Array.isArray(jsonContent.content)) {
            cleanedContent.content = jsonContent.content.reduce((acc, node)=>{
                var _jsonContent_type;
                const cleanedNode = this.cleanInvalidNodes(node, (_jsonContent_type = jsonContent.type) !== null && _jsonContent_type !== void 0 ? _jsonContent_type : contextType);
                if (cleanedNode) {
                    acc.push(cleanedNode);
                }
                return acc;
            }, []);
        }
        return cleanedContent;
    }
    isValidNode(node, contextType) {
        if (typeof node !== 'object' || node === null || typeof node.type !== 'string') {
            return false;
        }
        if (node.content && !Array.isArray(node.content)) {
            return false;
        }
        // No empty text
        if (node.type === 'text' && node.text === '') {
            return false;
        }
        if (contextType === 'doc') {
            // Remove invalid doc level items
            const invalidDocLevelNodes = [
                'hardBreak',
                'text'
            ];
            if (invalidDocLevelNodes.includes(node.type)) {
                return false;
            }
        }
        if (contextType === 'bulletList' || contextType === 'orderedList') {
            // Remove any node that isnt a list item
            if (node.type !== 'listItem') {
                return false;
            }
        }
        return true;
    }
    constructor(){
        _define_property(this, "cleaned", false);
        _define_property(this, "cleanedNodes", []);
    }
}

//# sourceMappingURL=json.js.map